import { sanitize } from 'dompurify'

export const unsecableSpaces = (str) => str.replace(/\s([?!:])/g, '&nbsp;$1')

export const getSafeTemplate = (reactElement) => unsecableSpaces(sanitize(reactElement))

export const cleanText = (text) => text.replace(/(\s*&nbsp;\s*)+/g, '<span class="unbreak-spaces">&nbsp;</span>')